import { render } from "./quotes.vue?vue&type=template&id=1fe8bf02&scoped=true"
import script from "./quotes.vue?vue&type=script&lang=js"
export * from "./quotes.vue?vue&type=script&lang=js"

import "./quotes.vue?vue&type=style&index=0&id=1fe8bf02&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe8bf02"]])

export default __exports__